// extracted by mini-css-extract-plugin
module.exports = {"custom_button":"styles_custom_button__3OHf1","search_button":"styles_search_button__1dSri"};